function Pakistan({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1863)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M0 15.9999C0 22.0646 3.37431 27.3407 8.34781 30.0544V1.94531C3.37431 4.659 0 9.93518 0 15.9999Z" fill="#F0F0F0"/>
  <path d="M16 0C13.2281 0 10.621 0.705188 8.34778 1.94544V30.0545C10.621 31.2948 13.2281 32 16 32C24.8365 32 32 24.8365 32 16C32 7.1635 24.8365 0 16 0Z" fill="#496E2D"/>
  <path d="M22.8408 18.6456C20.8166 20.1082 17.99 19.6529 16.5275 17.6288C15.0648 15.6046 15.5201 12.778 17.5443 11.3155C18.1755 10.8595 18.8846 10.5899 19.606 10.4963C18.2181 10.2887 16.7509 10.6014 15.5236 11.4883C13.0323 13.2884 12.4719 16.7672 14.272 19.2586C16.072 21.7498 19.5509 22.3103 22.0423 20.51C23.2697 19.6232 24.0273 18.3286 24.2659 16.9456C23.9505 17.6009 23.472 18.1896 22.8408 18.6456Z" fill="#F0F0F0"/>
  <path d="M22.754 10.4346L23.8943 11.6634L25.4153 10.9589L24.5989 12.4229L25.739 13.6518L24.0943 13.3278L23.2779 14.7919L23.0779 13.1275L21.4331 12.8034L22.9542 12.0989L22.754 10.4346Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Pakistan;
